export type ModalDetails = {
  newStatus: string;
  featureName: string;
};

export const defaultModalDetails: ModalDetails = {
  newStatus: '',
  featureName: ''
};
